import { ApiClient } from "./client";
export const PORTAL_API_ENDPOINTS_BY_ENV = {
    mainnet: "https://api.mezo.org/api/",
    testnet: "https://api.test.mezo.org/api/",
};
export class PortalApiClient extends ApiClient {
    constructor(environment = "mainnet", apiUrl) {
        super({
            apiUrl: apiUrl ?? PORTAL_API_ENDPOINTS_BY_ENV[environment],
            removeVersioning: true,
        });
    }
    async getPortalStatistics() {
        const data = await this.handleRequest("/v1/statistics", {
            method: "GET",
        });
        return data;
    }
    async getPortalMats(address) {
        const data = await this.handleRequest(`/v2/account/${address}/mats`, {
            method: "GET",
        });
        return data;
    }
}
//# sourceMappingURL=portal.js.map